import React from "react";
import styles from "./text.module.scss";
import classnames from "classnames";

export type TextSizeProps = "extraExtraSmall" | "extraSmall" | "small" | "midSmall" | "medium" | "large" | "extraLarge" | "huge" | "midLarge";

export type TextWeightProps = "extraBold" | "midBold" | "bold" | "normal" | "thin";

export interface TextProps extends React.HTMLAttributes<HTMLSpanElement> {
  skin?: "standard" | "error" | "primary";
  weight?: TextWeightProps;
  testId?: string;
  size?: TextSizeProps;
  secondary?: boolean;
  className?: string;
  onClick?: VoidFunction;
  capitalize?: boolean;
}
export const Text: React.FC<TextProps> = React.memo(
  ({ children, testId, skin = "standard", weight = "normal", size = "medium", secondary, className, onClick, capitalize, ...args }) => {
    return (
      <span
        onClick={onClick}
        data-testid={testId}
        className={classnames(styles[skin], styles[weight], styles[size], { [styles.secondary]: secondary }, className)}
        {...args}
      >
        {capitalize ? children?.toString().toUpperCase() : children}
      </span>
    );
  }
);
